import React from 'react';
import classes from './style.module.scss';
import useTranslation from '~/app/hooks/useTranslation';
import { TrainingDetail } from '~/training/types';

export interface TrainingChecklistProps {
  checklist: TrainingDetail['checklist'];
}

export type TrainingChecklistComponent = React.FC<TrainingChecklistProps>;

const TrainingChecklist: TrainingChecklistComponent = ({ checklist }) => {
  const { t } = useTranslation('training');

  return (
    <div className={classes['section']}>
      <div className={classes['title']}>{t('checklist')}</div>
      <ul className={classes['checklist']}>
        {checklist.map((item) => (
          <li key={item.id} className={classes['checklist-item']}>
            <span
              className={`${classes['check-icon']} ${item.isChecked ? classes['done'] : ''}`}
            />
            <span className={classes['check-text']}>{item.title}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TrainingChecklist;
